module.exports = {
    // basic
    'reset-password': 'reset password',

    // raw
    'reset-password-success': 'Password successfully reset.',
    'reset-password-fail': `
        <p>
            We were unable to complete your request.
        </p>
        <p>
            Please contact WellDrive Operations for assistance.
        </p>
        <p>
            <a href="#login" class="forgot-password-link">Back to Sign In page</a>
        </p>
    `,
    'password-empty': 'You must enter your current password.',
    'new-password-empty': 'You must enter a new password.',
    'password-confirmation-mismatch': 'Your password and password confirmation must match.',

    // template
};
